function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#6EC18A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.44
}, React.createElement("path", {
  d: "M6.186 11.708L11.222 17.562 25.491 0",
  transform: "translate(3.446 3.446)"
}), React.createElement("path", {
  d: "M22.009 12.544c.703 4.497-1.48 8.954-5.469 11.17-3.989 2.216-8.941 1.722-12.41-1.238C.66 19.516-.593 14.716.99 10.448 2.575 6.18 6.66 3.345 11.226 3.345c1.44-.002 2.867.281 4.197.833",
  transform: "translate(3.446 3.446)"
}));

var SvgConfirmationSmall = function SvgConfirmationSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfirmationSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ConfirmationSmall.c9bf02bc.svg";
export { ForwardRef as ReactComponent };